    import axiosAuth from '../../../shared/configs/axios-auth'
    import router from '@/router'
    
    const getDefaultState = () => {
        return {
            orders: null,
            orderState: {},
            order: null,
            storedOrder: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        orders: state => {
            return state.orders
        },
        order: state => {
            return state.order
        },
        orderState: state => {
            return state.orderState
        },
        storedOrder: state => {
            return state.storedOrder
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        orders: (state, payload) => {
            state.orders = payload
        },
        order: (state, payload) => {
            state.order = payload
        },
        orderState: (state, payload) => {
            state.orderState = payload
        },
        storedOrder: (state, payload) => {
            state.storedOrder = payload
        },
    }

    const actions = {
       
        getOrder: ({commit}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/orders/order/' + payload._id)
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('order', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)

                }
              )
        },

        postOrder ({commit}, payload) {
            commit('updating', true)
            payload.version = process.env.VUE_APP_VERSION;
            axiosAuth.post('/orders', payload)
                .then(
                    res => {
                        console.log(res)
                        if(res.data.message){
                            commit('orderState', res.data.message)
                        }else{
                            commit('orderState', res.data)
                        }
                        commit('storedOrder', res.data.order)
                        commit('updating', false)
                        if(res.data.confirmation_required === false){
                            router.push('/bestellung/'+ res.data.orderId).catch((err) => {console.log(err)})      
                        }
                    }
                )
                .catch(
                error => {
                    commit('storedOrder', null)
                    console.log(error.response)
                    commit('updating', false)
                }
            )
        },

        postRating ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/orders/postrating/' + payload._id , payload)
                .then(
                    () => {
                        dispatch('getOrder', {_id: payload._id})
                        commit('updating', false)
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            )
        },

        resendConfirmation ({commit}, payload) {
            commit('updating', true)
            axiosAuth.post('/orders/resendconfirmation/' + payload._id)
                .then(
                    res => {
                        commit('orderState', res.data)
                        commit('updating', false)
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            )
        },

        confirmOrder: ({commit}, payload) => {           
            commit('updating', true)
            axiosAuth.patch('/orders/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('orderState', res.data)
                    commit('updating', false)
                    if(payload.change_route){
                        router.push('/bestellung/'+ payload._id).catch((err) => {console.log(err)})      
                    }
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    error.response.data.order = state.orderState.order
                    commit('orderState', error.response.data)
                    commit('updating', false)
                }
            ) 
        }

    }

    export default {
        state,
        getters,
        mutations,
        actions
    }